<div class="w-full h-full">
  <router-outlet>
    <ngx-spinner [zIndex]="10000000"
    bdColor="rgba(0, 0, 0, 0.8)"
    size="large"
    color="#fff"
    type="ball-spin"
    [fullScreen]="true"
  >
    <p style="color: white">Please wait...</p>
  </ngx-spinner>
  </router-outlet>
</div>